import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MutualModule } from '@shared/mutual/mutual.module';
import { RouterModule } from '@angular/router';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { NgxPaginationModule } from 'ngx-pagination';

import { HouseBillEditComponent, HouseBillListComponent, HouseBillMasterBillViewComponent, HouseBillViewComponent } from './components';
import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';

@NgModule({
  declarations: [HouseBillListComponent, HouseBillEditComponent, HouseBillViewComponent, HouseBillMasterBillViewComponent],
  imports: [CommonModule, MutualModule, RouterModule, FormWrapperModule, PipesSharedModule, NgxPaginationModule],
  exports: [HouseBillListComponent, HouseBillEditComponent, HouseBillViewComponent, HouseBillMasterBillViewComponent],
})
export class HouseBillsModule {}
